import Fullpagelogin from './components/Fullpagelogin';
import { AppMessageProvider } from './AppMessageProvider';

function App() {
    return (
        <AppMessageProvider>
            <Fullpagelogin />
        </AppMessageProvider>
    );
}
export default App;
